export enum Programs {
    somatuline = 'submit-claim-somatuline',
    dysport = 'submit-claim-dysport',
    onivyde = 'submit-claim-onivyde',
}
